import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function NoSelection({
  className
}) {
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    viewBox: "0 0 96 96",
    children: [/*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "a",
        children: /*#__PURE__*/_jsx("rect", {
          width: "83.94",
          height: "92",
          fill: "#333"
        })
      })
    }), /*#__PURE__*/_jsxs("g", {
      transform: "translate(22394 9399)",
      children: [/*#__PURE__*/_jsx("rect", {
        width: "96",
        height: "96",
        transform: "translate(-22394 -9399)",
        fill: "#333",
        opacity: "0"
      }), /*#__PURE__*/_jsx("g", {
        transform: "translate(-22388 -9397)",
        children: /*#__PURE__*/_jsxs("g", {
          clipPath: "url(#a)",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M15.97,43c5.7,0,10-4.546,10-10.572V29.57c0-6.026-4.3-10.57-10-10.57s-10,4.544-10,10.57v2.858c0,6.026,4.3,10.572,10,10.572m-6-13.43c0-3.806,2.524-6.57,6-6.57s6,2.764,6,6.57v2.858c0,3.808-2.524,6.572-6,6.572s-6-2.764-6-6.572Z",
            transform: "translate(5.97 19)",
            fill: "#333"
          }), /*#__PURE__*/_jsx("path", {
            d: "M45.89,49.778,45.692,48H32.812L18.85,32H13.94C8.87,32,5.524,35.208,4,41.516l-4,16,3.882.97,4-16.016C9.27,36.736,11.848,36,13.94,36h3.092L30.994,52H41.876a5.443,5.443,0,0,1-1.138,2.95A3.6,3.6,0,0,1,37.9,56H26.878l-9.4-11.28L14.4,47.282,21.67,56H17.94v4h64V56H44.8a12.041,12.041,0,0,0,1.092-6.222",
            transform: "translate(0 32)",
            fill: "#333"
          }), /*#__PURE__*/_jsx("path", {
            d: "M31.838,52v4h18a2,2,0,0,0,1.756-1.042l12-22A2,2,0,0,0,61.838,30h-36A2,2,0,0,0,24.1,31.008l-8,14,3.472,1.984L27,34h31.47L48.65,52Z",
            transform: "translate(16.102 30)",
            fill: "#333"
          }), /*#__PURE__*/_jsx("path", {
            d: "M59.97,0h-36a8.008,8.008,0,0,0-8,8V34a8.008,8.008,0,0,0,8,8h2v8a3.944,3.944,0,0,0,2.736,3.794,4.074,4.074,0,0,0,1.3.214A3.94,3.94,0,0,0,33.17,52.4L40.97,42h17a10.011,10.011,0,0,0,10-10V8a8.008,8.008,0,0,0-8-8m4,32a6.007,6.007,0,0,1-6,6h-18a2,2,0,0,0-1.6.8L29.97,50V40a2,2,0,0,0-2-2h-4a4,4,0,0,1-4-4V8a4,4,0,0,1,4-4h36a4,4,0,0,1,4,4Z",
            transform: "translate(15.97)",
            fill: "#333"
          }), /*#__PURE__*/_jsx("path", {
            d: "M42.263,5.293l-7.586,7.586L27.091,5.293,24.263,8.121l7.586,7.586-7.586,7.586,2.828,2.828,7.586-7.586,7.586,7.586,2.828-2.828-7.586-7.586,7.586-7.586Z",
            transform: "translate(24.263 5.293)",
            fill: "#333"
          })]
        })
      })]
    })]
  });
}